if (!customElements.get('learn-your-way')) {
  class LearnYourWay extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.desktopBreakpoint = 1024;
      this.desktopVisibleCards = 4;
      this.handleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      this.handleResize();
      window.addEventListener('resize', this.handleResize);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
      this.destroy();
    }

    get swiperContainer() {
      return this.querySelector('.learn-your-way__slider');
    }

    get paginationEl() {
      return this.querySelector('.swiper-pagination');
    }

    get prevButtonEl() {
      return this.querySelector('.swiper-button-prev');
    }

    get nextButtonEl() {
      return this.querySelector('.swiper-button-next');
    }

    get slides() {
      return this.querySelectorAll('.swiper-slide');
    }

    getConfig() {
      return {
        slidesPerView: 1,
        slidesOffsetAfter: 12,
        slidesOffsetBefore: 12,
        spaceBetween: 12,
        centeredSlides: false,
        grabCursor: true,
        pagination: {
          el: this.paginationEl,
          type: 'fraction',
        },
        keyboard: {
          enabled: true,
        },
        navigation: {
          nextEl: this.nextButtonEl,
          prevEl: this.prevButtonEl,
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
            slidesPerGroup: 1,
            spaceBetween: 20,
            slidesOffsetAfter: 20,
            slidesOffsetBefore: 20,
          },
          1024: {
            slidesPerView: 4,
            slidesPerGroup: 1,
            slidesOffsetAfter: 0,
            slidesOffsetBefore: 0,
            spaceBetween: 12,
          },
        },
      };
    }

    handleResize() {
      const isDesktop = window.innerWidth >= this.desktopBreakpoint;
      const slideCount = this.slides.length;
      const shouldUseSliderDesktop = slideCount > this.desktopVisibleCards;

      if (isDesktop) {
        if (shouldUseSliderDesktop) {
          if (!this.swiper) {
            this.init();
          }
        } else {
          if (this.swiper) {
            this.destroy();
          }
        }
      } else {
        if (!this.swiper) {
          this.init();
        }
      }
    }

    init() {
      if (this.swiperContainer) {
        this.classList.add('slider-active');
        this.swiper = new Swiper(this.swiperContainer, this.getConfig());

        if (this.swiper.pagination) {
          this.swiper.pagination.update();
        }

        if (this.swiper.navigation) {
          this.swiper.navigation.update();
        }
      }
    }

    destroy() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
      this.classList.remove('slider-active');
    }
  }

  customElements.define('learn-your-way', LearnYourWay);
}
